import { Size } from '@ps/web-core-enums';
import type { Menu, Page, Reference } from '@ps/web-martech-cms-types';
import { useScreenSize } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';
import { useIntl } from 'react-intl';

import { useCMSReference } from '@swf/cms';

import CMSNavigationSubmenuItem from '../CMSNavigationSubmenuItem/CMSNavigationSubmenuItem';

import { TXTCLI_Show_More_Options } from './CMSNavigationSubmenuChildren.messages.json';
import styles from './CMSNavigationSubmenuChildren.scss';

interface Props {
  parentUrl?: string;
  parentPageRef?: Reference[];
  menuItems: Menu[];
  onSelect: () => void;
}

const ItemLimit = 8;

const CMSNavigationSubmenuChildren: React.FC<Props> = ({
  menuItems,
  parentUrl,
  parentPageRef,
  onSelect
}) => {
  const { formatMessage } = useIntl();
  const { greaterThan } = useScreenSize();
  const page = useCMSReference<Page>(parentPageRef?.[0]);
  const parentHref = parentUrl || page?.url;

  return (
    <ul className={styles.subMenu}>
      {menuItems.map(({ heading, url, uid, page, resolver_tag: resolverTag }, index) => {
        const itemLimit = greaterThan(Size.Small) && parentHref ? ItemLimit : menuItems.length;
        return (
          index <= itemLimit && (
            <li key={uid} className={styles.subMenuItem}>
              <CMSNavigationSubmenuItem
                pageRef={itemLimit === index ? parentPageRef : page}
                url={itemLimit === index ? parentUrl : url}
                resolverTag={resolverTag}
                heading={itemLimit === index ? formatMessage(TXTCLI_Show_More_Options) : heading}
                itemCount={itemLimit === index ? menuItems.length - itemLimit : undefined}
                className={classNames(styles.subMenuItem, {
                  [styles.showMore]: itemLimit === index
                })}
                onSelect={onSelect}
              />
            </li>
          )
        );
      })}
    </ul>
  );
};

export default CMSNavigationSubmenuChildren;
